"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeFollowPopup = void 0;
var React = require("react");
var format_1 = require("@/utils/format");
var classnames_1 = require("classnames");
exports.placeFollowPopup = function (props) {
    if (props.saveSearchId > -1)
        return null;
    var isNoListing = props.availablePropertiesSale.length + props.availablePropertiesRent.length === 0;
    var title = isNoListing ? props.t.followPopupTitle2 : props.t.followPopupTitle;
    var caption = isNoListing ?
        format_1.default.print(props.t.followPopupCaption2, [props.nameMain, props.district]) :
        format_1.default.print(props.t.followPopupCaption, [props.nameMain]);
    var renderFollow = function (props, isNoListing) {
        var cancel = isNoListing ? props.t.followPopupCancel2 : props.t.followPopupCancel;
        var follow = format_1.default.print(isNoListing ? props.t.followPopupFollow2 : props.t.followPopupFollow, [props.nameMain]);
        return (React.createElement("div", { className: "c-bigpopup__actions" },
            React.createElement("div", { className: "c-bigpopup__action" },
                React.createElement("a", { onClick: props.onFollowPopupCloseClick, className: "o-textbtn" }, cancel)),
            React.createElement("div", { className: "c-bigpopup__action" },
                React.createElement("button", { onClick: props.followClicked, className: "o-btn o-btn--primary u-md" },
                    React.createElement("span", { className: "fal fa-bell" }),
                    "\u00A0",
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: follow } })))));
    };
    var renderRenderBuyRent = function (props, isNoListing) {
        var buyButton = format_1.default.print(props.t.followPopupSearchBuy, [props.district]);
        var rentButton = format_1.default.print(props.t.followPopupSearchRent, [props.district]);
        var buyHref = "/" + props.lang + "/property-search/buy/" + format_1.default.normalize(props.district);
        var rentHref = "/" + props.lang + "/property-search/rent/" + format_1.default.normalize(props.district);
        return (React.createElement("div", { className: "c-bigpopup__actions" },
            React.createElement("div", { className: "c-bigpopup__action" },
                React.createElement("a", { href: buyHref, className: "o-btn o-btn--primary u-md" },
                    React.createElement("span", { className: "fal fa-search" }),
                    "\u00A0",
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: buyButton } }))),
            React.createElement("div", { className: "c-bigpopup__action" },
                React.createElement("a", { href: rentHref, className: "o-btn o-btn--primary u-md" },
                    React.createElement("span", { className: "fal fa-search" }),
                    "\u00A0",
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: rentButton } })))));
    };
    var searchImage = isNoListing ? '/res/img/search.png' : '/res/img/notification.png';
    var popupClass = classnames_1.default([
        'l-fullscreen-dim',
        'l-fullscreen-dim--center',
        'c-bigpopup',
        'c-bigpopup--question',
        {
            'l-fullscreen-dim--active': props.followPopupActive,
        },
    ]);
    var onFollowPopupPanelClick = function (event) {
        if (event.currentTarget === event.target)
            props.onFollowPopupCloseClick();
    };
    return (React.createElement("div", { className: popupClass, onClick: onFollowPopupPanelClick },
        React.createElement("div", { className: "c-bigpopup__main" },
            React.createElement("div", { onClick: props.onFollowPopupCloseClick, className: "c-bigpopup__close" },
                React.createElement("span", { className: "fal fa-times" })),
            React.createElement("div", { className: "c-bigpopup__body" },
                React.createElement("div", { className: "c-bigpopup__pic" },
                    React.createElement("img", { loading: "lazy", src: searchImage, alt: title })),
                React.createElement("div", { className: "c-bigpopup__title" }, title),
                React.createElement("div", { className: "c-bigpopup__caption", dangerouslySetInnerHTML: { __html: caption } }),
                isNoListing ? renderRenderBuyRent(props, isNoListing) : renderFollow(props, isNoListing)))));
};
